import { useEffect, useState } from "react";
import styles from "./EmployeesInfo.module.scss";

import profilePhoto from "../../assets/images/profile_photo.svg";
import getEmployeesInfo from "services/employess.service";
import UserInfo from "components/UserInfo";

export const EmployeesInfo = () => {
  const [activeTab, setActiveTab] = useState("Ukraine");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [employeesInfo, setEmployeesInfo] = useState([]);
  const [currentRowId, setCurrentRowId] = useState(null);
  const initialOpenFileRows = employeesInfo.map(() => false);
  const [openFileRows, setOpenFileRows] = useState(initialOpenFileRows);

  const listWrapper = document.getElementById(
    `${currentRowId + "listWrapper"}`,
  );
  const fileList = document.getElementById(`${currentRowId + "fileList"}`);
  const toHeight = fileList?.scrollHeight;

  if (listWrapper) {
    listWrapper.style.maxHeight = openFileRows[currentRowId]
      ? `${toHeight}px`
      : "0px";
  }

  if (fileList) {
    fileList.style.opacity = openFileRows[currentRowId] ? `1` : "0";
  }

  useEffect(() => {
    setIsLoading(true);
    (async () => {
      try {
        const { data } = await getEmployeesInfo();
        if (data.length === 0) {
          setError(true);
        }
        setEmployeesInfo(data);
      } catch (err) {
        setError(err);
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setOpenFileRows(initialOpenFileRows);
  };

  const toggleFiles = (idx) => {
    setCurrentRowId(idx);
    const updatedOpenFileRows = [...openFileRows];
    updatedOpenFileRows[idx] = !updatedOpenFileRows[idx];
    setOpenFileRows(updatedOpenFileRows);
  };

  return (
    <>
      <section className={styles.sectionEpmloyeesContainer}>
        <div className={styles.pageNameContainer}>
          <div className={styles.pageName}>Employees info</div>
          <div className={styles.pageNameUnderline}></div>
        </div>
        <div className={styles.employeesContainer}>
          <div className={styles.tabContainer}>
            <button
              type="button"
              onClick={() => handleTabChange("Ukraine")}
              className={`${styles.tabCountry} ${
                activeTab === "Ukraine" && styles.activeTab
              }`}
            >
              Ukraine
            </button>
            <button
              type="button"
              onClick={() => handleTabChange("Poland")}
              className={`${styles.tabCountry} ${
                activeTab === "Poland" && styles.activeTab
              }`}
            >
              Poland
            </button>
          </div>
          <div className={styles.wrapper}>
            {isLoading ? (
              <div className={styles.loader}>
                <p>loading...</p>
              </div>
            ) : !error ? (
              <div className={styles.contentContainer}>
                {" "}
                <table className={styles.tableEmployees}>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Date&nbsp;of Birth</th>
                      <th>Adress</th>
                      <th>Phone</th>
                      <th>Social Link</th>
                      <th>Emergency Contact</th>
                      {activeTab === "Ukraine" ? (
                        <>
                          <th>Passport UA</th>
                          <th>Passport foreign</th>
                          <th>Propiska</th>
                          <th>INN</th>
                          <th>FOP</th>
                          <th>FOP2</th>
                          <th>Files</th>
                        </>
                      ) : (
                        <>
                          <th>Passport</th>
                          <th>Visa</th>
                          <th>Pesel</th>
                          <th>JDG</th>
                          <th>Files</th>
                        </>
                      )}
                    </tr>
                  </thead>

                  <tbody>
                    <>
                      {employeesInfo.map(
                        (
                          {
                            id,
                            firstName = "No firstName available",
                            lastName = "No lastName available",
                            dateOfBirth = 0,
                            email = 0,
                            address = 0,
                            phone = 0,
                            social_network = 0,
                            emergency_contacts = 0,
                            documents_list = [],
                            location = 0,
                            passport_foreign = 0,
                            propiska = 0,
                            inn = 0,
                            passport = 0,
                            fop_vypyska = 0,
                            fop_vypyska_2 = 0,
                            visa = 0,
                            pesel = 0,
                            wydruk = 0,
                            photoUrl,
                          },
                          idx,
                        ) => {
                          return (
                            location === activeTab && (
                              <tr key={idx}>
                                <td onClick={() => toggleFiles(idx)}>
                                  <div>
                                    <UserInfo
                                      src={photoUrl ?? profilePhoto}
                                      name={firstName + " " + lastName}
                                      className={styles.userInfo}
                                    />
                                  </div>
                                </td>
                                <td onClick={() => toggleFiles(idx)}>
                                  <div
                                    className={
                                      email ? styles.positive : styles.negative
                                    }
                                  >
                                    {email ? "+" : "-"}
                                  </div>
                                </td>
                                <td onClick={() => toggleFiles(idx)}>
                                  <div
                                    className={
                                      dateOfBirth
                                        ? styles.positive
                                        : styles.negative
                                    }
                                  >
                                    {dateOfBirth ? "+" : "-"}
                                  </div>
                                </td>
                                <td onClick={() => toggleFiles(idx)}>
                                  <div
                                    className={
                                      address
                                        ? styles.positive
                                        : styles.negative
                                    }
                                  >
                                    {address ? "+" : "-"}
                                  </div>
                                </td>
                                <td onClick={() => toggleFiles(idx)}>
                                  <div
                                    className={
                                      phone ? styles.positive : styles.negative
                                    }
                                  >
                                    {phone ? "+" : "-"}
                                  </div>
                                </td>
                                <td onClick={() => toggleFiles(idx)}>
                                  <div
                                    className={
                                      social_network
                                        ? styles.positive
                                        : styles.negative
                                    }
                                  >
                                    {social_network ? "+" : "-"}
                                  </div>
                                </td>
                                <td onClick={() => toggleFiles(idx)}>
                                  <div
                                    className={
                                      emergency_contacts
                                        ? styles.positive
                                        : styles.negative
                                    }
                                  >
                                    {emergency_contacts ? "+" : "-"}
                                  </div>
                                </td>
                                <td onClick={() => toggleFiles(idx)}>
                                  <div
                                    className={
                                      passport
                                        ? styles.positive
                                        : styles.negative
                                    }
                                  >
                                    {passport ? "+" : "-"}
                                  </div>
                                </td>
                                {location === "Ukraine" && (
                                  <>
                                    <td onClick={() => toggleFiles(idx)}>
                                      <div
                                        className={
                                          passport_foreign
                                            ? styles.positive
                                            : styles.negative
                                        }
                                      >
                                        {passport_foreign ? "+" : "-"}
                                      </div>
                                    </td>
                                    <td onClick={() => toggleFiles(idx)}>
                                      <div
                                        className={
                                          propiska
                                            ? styles.positive
                                            : styles.negative
                                        }
                                      >
                                        {propiska ? "+" : "-"}
                                      </div>
                                    </td>
                                    <td onClick={() => toggleFiles(idx)}>
                                      <div
                                        className={
                                          inn
                                            ? styles.positive
                                            : styles.negative
                                        }
                                      >
                                        {inn ? "+" : "-"}
                                      </div>
                                    </td>
                                    <td onClick={() => toggleFiles(idx)}>
                                      <div
                                        className={
                                          fop_vypyska
                                            ? styles.positive
                                            : styles.negative
                                        }
                                      >
                                        {fop_vypyska ? "+" : "-"}
                                      </div>
                                    </td>
                                    <td onClick={() => toggleFiles(idx)}>
                                      <div
                                        className={
                                          fop_vypyska_2
                                            ? styles.positive
                                            : styles.negative
                                        }
                                      >
                                        {fop_vypyska_2 ? "+" : "-"}
                                      </div>
                                    </td>
                                  </>
                                )}
                                {location === "Poland" && (
                                  <>
                                    <td onClick={() => toggleFiles(idx)}>
                                      <div
                                        className={
                                          visa
                                            ? styles.positive
                                            : styles.negative
                                        }
                                      >
                                        {visa ? "+" : "-"}
                                      </div>
                                    </td>
                                    <td onClick={() => toggleFiles(idx)}>
                                      <div
                                        className={
                                          pesel
                                            ? styles.positive
                                            : styles.negative
                                        }
                                      >
                                        {pesel ? "+" : "-"}
                                      </div>
                                    </td>
                                    <td onClick={() => toggleFiles(idx)}>
                                      <div
                                        className={
                                          wydruk
                                            ? styles.positive
                                            : styles.negative
                                        }
                                      >
                                        {wydruk ? "+" : "-"}
                                      </div>
                                    </td>
                                  </>
                                )}
                                <td>
                                  <button
                                    type="button"
                                    className={styles.filesBtn}
                                    onClick={() => toggleFiles(idx)}
                                  >
                                    {openFileRows[idx]
                                      ? "Close Files"
                                      : "Open Files"}
                                  </button>
                                  <div
                                    id={`${idx + "listWrapper"}`}
                                    className={styles.listWrapper}
                                  >
                                    {" "}
                                    {true && (
                                      <ol
                                        id={`${idx + "fileList"}`}
                                        className={styles.fileList}
                                      >
                                        {documents_list !== null &&
                                        documents_list.length > 0 ? (
                                          documents_list.map((file, index) => (
                                            <li key={index}>{file}</li>
                                          ))
                                        ) : (
                                          <p>No documents.</p>
                                        )}
                                      </ol>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            )
                          );
                        },
                      )}
                    </>
                  </tbody>
                </table>
              </div>
            ) : (
              <p className={styles.loader}>We don't have any employees yet</p>
            )}
          </div>
        </div>
      </section>
    </>
  );
};
